import { consumeRelicAoE } from '../../domain/aramRules.js';
import {
  isChampionOnAltar,
  tickAltarCapture,
  syncAltarTeamBuffs
} from '../../domain/map/ttAltarRules.js';

/**
 * objectiveSystem — Orchestrates map objectives (relics + altars). (AR-03 updated)
 * Domain owns formulas; this module only wires tick order.
 *
 * Contrato: updateObjectives(relics, altars, playerEntity, entities, dt, gameTime?)
 */
export function updateObjectives(relics, altars, playerEntity, entities, dt, gameTime = 0) {
  tickRelicCooldowns(relics, dt);
  updateRelics(relics, playerEntity, entities);
  updateAltars(altars, entities, dt, gameTime);
}

const RELIC_COOLDOWN_SECONDS = 60;

function tickRelicCooldowns(relics, dt) {
  if (!relics) return;
  relics.forEach(rel => {
    if (rel.active) return;
    const next = Math.max(0, (rel.cooldownTimer || 0) - dt);
    rel.cooldownTimer = next;
    rel.active = next === 0;
  });
}

function updateRelics(relics, playerEntity, entities) {
  if (!relics || !playerEntity) return;
  relics.forEach((rel, idx) => {
    if (!rel.active) return;
    const res = consumeRelicAoE(rel, playerEntity, entities);
    if (res.consumed) {
      relics[idx] = res.relic;
      relics[idx].cooldownTimer = RELIC_COOLDOWN_SECONDS;
    }
  });
}

function updateAltars(altars, entities, dt, gameTime) {
  if (!altars || altars.length === 0) return;

  altars.forEach((alt, idx) => {
    const capturer = findAltarCapturer(alt, entities);
    altars[idx] = tickAltarCapture(alt, capturer?.team || null, dt, {
      gameTime,
      onAltar: !!capturer
    });
  });

  const champions = (entities || []).filter(e => e && e.type === 'champion');
  syncAltarTeamBuffs(champions, altars);
}

function findAltarCapturer(altar, entities) {
  if (!Array.isArray(entities)) return null;
  return entities.find(e =>
    e &&
    e.type === 'champion' &&
    !e.isDead &&
    isChampionOnAltar(e, altar)
  ) || null;
}
